import React from "react";
import { Grid, Card, CardContent, Button, Link } from "@material-ui/core";
import { makeStyles, Tooltip } from "@material-ui/core";
import "./BuyPHNX.css";

// import UniswapIcon from "../../../Assets/uniswap.png";
import BittrexIcon from "../../../Assets/Bittrex.svg";
import BittrexDark from "../../../Assets/bittrex-dark.svg";
// import CoinexIcon from "../../../Assets/coinEx.png";
// import ProbitIcon from "../../../Assets/probit.png";
// import NumioIcon from "../../../Assets/numio.png";

import UniswapLight from "../../../Assets/trade/uniswapLight.png";
import UniswapDark from "../../../Assets/trade/uniswapDark.png";
import StexLight from "../../../Assets/trade/stexLight.png";
import StexDark from "../../../Assets/trade/stexDark.png";
import CoinexLight from "../../../Assets/trade/coinexLight.png";
import CoinexDark from "../../../Assets/trade/coinexDark.png";
import ProbitLight from "../../../Assets/trade/probitLight.png";
import ProbitDark from "../../../Assets/trade/probitDark.png";
import NumioLight from "../../../Assets/trade/numioLight.png";
import NumioDark from "../../../Assets/trade/numioDark.png";
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
  myCard: {
    background: theme.palette.card.main,
    height: "100%",
    padding: "12px 0px",
    borderRadius: "8px",
  },

  tradeIcons: {
    height: 32,
    "@media (min-width: 2400px)": {
      height: 48,
    },
  },

  myPara: {
    fontSize: 24,
    "@media (min-width: 2400px)": {
      fontSize: 32,
    },
  },

  myHeading: {
    fontSize: 32,
    fontWeight: "bold",
    "@media (min-width: 2400px)": {
      fontSize: 48,
    },
  },
}));

const BuyPHNX = (props) => {
  const themeMode = localStorage.getItem("themeMode");
  const classes = useStyles();

  return (
    <Grid xs={12} style={{ height: "100%" }} contianer item>
      <Grid
        xs={12}
        style={{ height: "35%", paddingTop: "32px", paddingBottom: "12px" }}
        justify="space-around"
        item
      >
        <Card className={classes.myCard}>
          <Tooltip title="This is the total amount of $PHNX that has been staked globally.">
            <CardContent>
              <div className={classes.myPara}>
                <span style={{ color: "#9A9A9A" }}> Total </span>
                <span style={{ color: "#EA8604" }}>PHNX Staked</span>
              </div>
              <div style={{ marginTop: 15 }}>
                <span className={classes.myHeading}>
                  {props.totalStaked
                    ? props.totalStaked
                        .toString()
                        .match(/^-?\d+(?:\.\d{0,2})?/)[0]
                    : 0}
                </span>

                {/* <span style={{ marginLeft: 5, color: "#BDBDBD" }}>PHNX</span> */}
              </div>
            </CardContent>
          </Tooltip>
        </Card>
      </Grid>
      <Grid
        xs={12}
        style={{ height: "65%", paddingBottom: "12px" }}
        justify="space-around"
        item
      >
        <Card className={classes.myCard}>
          <CardContent>
            <div className={classes.myPara}>
              <span style={{ color: "#9A9A9A" }}> Buy </span>
              <span style={{ color: "#EA8604" }}>PHNX tokens</span>
            </div>
          </CardContent>
          <div className="contentScroll">
            <CardContent style={{ display: "flex", justifyContent: "center" }}>
              <img
                className={classes.tradeIcons}
                style={{ margin: "auto 0px" }}
                src={themeMode === "light" ? UniswapLight : UniswapDark}
                alt="exchange links"
              />

              <Button className="tradeButton">
                <Link
                  href="https://app.uniswap.org/#/swap"
                  rel="noreferrer"
                  target="_blank"
                  style={{
                    textDecoration: "none",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  Trade
                </Link>
              </Button>
            </CardContent>
            <CardContent style={{ display: "flex", justifyContent: "center" }}>
              <img
                className={classes.tradeIcons}
                style={{ margin: "auto 0px" }}
                src={themeMode === "light" ? BittrexIcon : BittrexDark}
                alt="exchange links"
              />

              <Button className="tradeButton">
                <Link
                  href="https://global.bittrex.com/Market/Index?MarketName=BTC-PHNX"
                  rel="noreferrer"
                  target="_blank"
                  style={{
                    textDecoration: "none",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  Trade
                </Link>
              </Button>
            </CardContent>
            <CardContent style={{ display: "flex", justifyContent: "center" }}>
              <img
                className={classes.tradeIcons}
                style={{ margin: "auto 0px" }}
                src={themeMode === "light" ? StexLight : StexDark}
                alt="exchange links"
              />
              <Button className="tradeButton">
                <Link
                  href="https://app.stex.com/en/trade/pair/BTC/PHNX/1D"
                  rel="noreferrer"
                  target="_blank"
                  style={{
                    textDecoration: "none",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  Trade
                </Link>
              </Button>
            </CardContent>
            <CardContent style={{ display: "flex", justifyContent: "center" }}>
              <img
                className={classes.tradeIcons}
                style={{ margin: "auto 0px" }}
                src={themeMode === "light" ? CoinexLight : CoinexDark}
                alt="exchange links"
              />
              <Button className="tradeButton">
                <Link
                  href="https://www.coinex.com/exchange?currency=btc&dest=phnx"
                  rel="noreferrer"
                  target="_blank"
                  style={{
                    textDecoration: "none",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  Trade
                </Link>
              </Button>
            </CardContent>
            <CardContent style={{ display: "flex", justifyContent: "center" }}>
              <img
                className={classes.tradeIcons}
                style={{ margin: "auto 0px" }}
                src={themeMode === "light" ? ProbitLight : ProbitDark}
                alt="exchange links"
              />
              <Button className="tradeButton">
                <Link
                  href="https://www.probit.com/app/exchange/PHNX-BTC"
                  rel="noreferrer"
                  target="_blank"
                  style={{
                    textDecoration: "none",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  Trade
                </Link>
              </Button>
            </CardContent>
            <CardContent style={{ display: "flex", justifyContent: "center" }}>
              <img
                className={classes.tradeIcons}
                style={{ margin: "auto 0px" }}
                src={themeMode === "light" ? NumioLight : NumioDark}
                alt="exchange links"
              />
              <Button className="tradeButton">
                <Link
                  href="https://numio.one/"
                  rel="noreferrer"
                  target="_blank"
                  style={{
                    textDecoration: "none",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  Trade
                </Link>
              </Button>
            </CardContent>
          </div>
        </Card>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    totalStaked: state.dashboardReducer.totalStaked,
  };
};

export default connect(mapStateToProps, null)(BuyPHNX);
